<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-form-item-inspeccion-export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar listado Item Inspección</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="nombre" class="col-md-5"
                      >Nombre</label
                    >
                    <input
                      type="text"
                      id="nombre"
                      v-model="filtros.nombre1"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="tipo_control" class="col-md-5"
                      >Tipo Control</label
                    >
                    <select
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_control1"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_control in listasForms.tipos_control"
                        :key="tipo_control.numeracion"
                        :value="tipo_control.numeracion"
                      >
                        {{ tipo_control.descripcion }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label for="tipo_calificacion_novedad" class="col-md-5"
                      >Tipo de Calificación</label
                    >
                    <select
                      id="tipo_calificacion_novedad"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.tipo_calificacion_novedad"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="tipo_calificacion_novedad in listasForms.tipos_calificacion_novedad"
                        :key="tipo_calificacion_novedad.numeracion"
                        :value="tipo_calificacion_novedad.numeracion"
                      >
                        {{ tipo_calificacion_novedad.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombre1"
                              v-model="form.nombre"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="nombre1"
                              >Nombre</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_control1"
                              v-model="form.tipo_control"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_control1"
                              >Tipo Control</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tamano_control1"
                              v-model="form.tamano_control"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tamano_control1"
                              >Tamaño Contro</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="tipo_calificacion_novedad1"
                              v-model="form.tipo_calificacion_novedad"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="tipo_calificacion_novedad1"
                              >	Tipo de Calificación</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExce()"
                v-if="$store.getters.can('admin.itemsInspeccion.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../../components/Loading";
//import vSelect from "vue-select";
export default {
  name: "ItemInspeccionExport", //llegada tambien
  components: { Loading, },
  data() {
    return {
      cargando:false,
      form: {
        nombre: true,
        tipo_control: true,
        tamano_control: true,
        tipo_calificacion_novedad: true,
      },
      filtros: {
        nombre1: null,
        tipo_control1: null,
        tipo_calificacion_novedad: null,
      },
      listasForms: {
        tipos_control: [],
        tipos_calificacion_novedad: [],
      },
    };
  },

  methods: {
    getTipoControl() {
      axios.get("/api/lista/14").then((response) => {
        this.listasForms.tipos_control = response.data;
      });
    },

    getTipoCalificacion() {
      axios.get("/api/lista/56").then((response) => {
        this.listasForms.tipos_calificacion_novedad = response.data;
      });
    },
    generarListadoExce() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/admin/itemsInspeccion/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    this.getTipoControl();
    this.getTipoCalificacion();
    this.cargando = false;
  },
};
</script>
